if (!window.__product_carousel_loaded) {
  window.__product_carousel_loaded = true;

  function initCarousel($slider) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 2,
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: '<span class="slick-previous-arrow"></span>',
      nextArrow: '<span class="slick-next-arrow"></span>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2.7,
            arrows: false,
            dots: true,
          }
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 1.7,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  function initProductCarousels() {
    document.querySelectorAll('.product-carousel-section').forEach(function(section) {
      // Initialize the first visible slider
      var activeContainer = section.querySelector('.carousel-products-container:not([style*="display: none"])');
      var $activeSlider = $('#' + activeContainer.querySelector('.carousel-products').id);

      initCarousel($activeSlider);
      setSlideHeight(activeContainer);

      window.onresize = () => {
        setTimeout(() => { setSlideHeight(activeContainer) }, 50);
      }

      // Handle category switching
      section.querySelectorAll('.carousel-category-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          // Active button
          section.querySelectorAll('.carousel-category-btn').forEach(function(b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');

          const slug = btn.getAttribute('data-slug');

          // Hide all containers
          section.querySelectorAll('.carousel-products-container').forEach(function(container) {
            container.style.display = 'none';
          });

          // Show the selected category
          var newContainer = section.querySelector('[data-category="' + slug + '"]');
          newContainer.style.display = '';

          // Initialize the slider if it is not already initialized
          var $newSlider = $('#' + newContainer.querySelector('.carousel-products').id);

          if (!$newSlider.hasClass('slick-initialized')) {
            initCarousel($newSlider);
          } else {
            $newSlider.slick('refresh');
          }

          setSlideHeight(newContainer);
        });
      });
    });
  }

  function setSlideHeight(container) {
    const track = container.querySelector('.slick-track');
    const slides = container.querySelectorAll('.slick-slide');
    if (track) {
      const trackHeight = track.offsetHeight;
      slides.forEach(slide => {
        slide.style.height = trackHeight + 'px';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initProductCarousels);
  document.addEventListener('shopify:section:load', initProductCarousels);
}
